import { Attribution, AssetRevenueAttribution, ResponseAttributionRecord } from '../../store/Attribution';
import { ResponseCustomerAttributionRecord } from '../../store/CustomerAttribution';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const downloadAttribution = (tallyRunId: number) => {
  return apiService.callExternalApi<Blob>({
    url: `${API_SERVER_URL}/attribution/export`,
    method: 'get',
    params: { tally_run_id: tallyRunId },
    responseType: 'blob'
  });
};

export const getAttributions = (entityType: string, entityId: string) => {
  return apiService.callExternalApi<ResponseAttributionRecord>({
    url: `${API_SERVER_URL}/attribution/${entityType}/${entityId}`,
    method: 'get'
  });
};

export const listAttributionsByTallyRun = (tallyRunId: number, view: string, filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'directSellerName', direction: 'asc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<Attribution>>({
    url: buildAdvancedQueryURL(mergedFilters, `direct-seller-attributions/${tallyRunId}/${view}`),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listAssetRevenueAttributions = (tallyRunId: number, filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'asset_upstack_id', direction: 'asc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<AssetRevenueAttribution>>({
    url: buildAdvancedQueryURL(mergedFilters, `attribution/asset-revenue/${tallyRunId}`),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getCustomerAttributions = (customerId: string, supplierId?: string) => {
  let params = '';
  if (supplierId) {
    params = `?supplier_id=${supplierId}`;
  }
  const url = `${API_SERVER_URL}/customer-attributions/${customerId}${params}`;
  return apiService.callExternalApi<ResponseCustomerAttributionRecord>({
    url: url,
    method: 'get'
  });
};
